import { ErrorDefinition } from './types';

export const commonErrors: Record<string, ErrorDefinition> = {
    'local-storage-required': {
        showRefreshButton: true,
        heading: 'Local storage required.',
        message: `You need to enable third-party data in your browser settings
                  to use this application. If you are using private mode in Safari,
                  please return with private mode disabled.`,
    },
    'session-storage-required': {
        showRefreshButton: true,
        heading: 'Session storage required.',
        message: `You need to enable third-party data in your browser settings
                  to use this application. If you are using private mode in Safari,
                  please return with private mode disabled.`,
    },
    'page-not-found': {
        html: true,
        heading: 'That doesn\'t seem to be here.',
        showHomeButton: true,
        message: '<p>The page you have requested was not found.</p>',
    },
    'cancelled-network-request': {
        showRefreshButton: true,
        warning: true,
        heading: 'Network connection issues',
        message:
            'The request has been canceled, either because of a page refresh or network issues.',
    },
    'network-outage': {
        showRefreshButton: true,
        heading: 'Network connection error',
        message: `There was a connection problem. These are usually
                  intermittent, so please wait a few minutes and try again.`,
    },
    'unauthorized': {
        showRefreshButton: true,
        heading: 'You don\'t have permission to use this application.',
        message: 'Please contact the account administrator for access.',
    },
    'unauthorized-feature': {
        showRefreshButton: true,
        heading: 'You don\'t have permission to use this feature.',
        message: 'Please contact the account administrator for access.',
    },
    'no-relying-parties': {
        showRefreshButton: true,
        showSignOutButton: true,
        warning: true,
        heading: 'You don\'t have permission to use this application.',
        message: 'Please contact the account administrator for access.',
    },
    'cookies-needed': {
        showRefreshButton: true,
        heading: 'Cookies are disabled.',
        message:
            'You need to enable third-party cookies and data in your browser settings to use this application.',
    },
    'unexpected': {
        showRefreshButton: true,
        heading: 'Uh oh, something went wrong!',
        message: `We're currently working on this, and should have things
                  back to normal soon. Please try again later.`,
    },
    // Reached when the tenant refuses a login outright -- an SSO user whose IdP groups earn no
    // role, a connection the Action cannot provision, an email that already has a password
    // account. The exact reason is in the console and the tenant log; it is deliberately not
    // shown here, because every one of these is resolved by an administrator rather than by the
    // person reading the page.
    'access-denied': {
        // No refresh -- retrying the same refused login just lands back here. Sign out is the one
        // control that helps: the person is holding a LIVE Auth0 session at this point, so without
        // it the page has no way off it but editing the URL, and signing in as somebody else is
        // exactly what an account refused access needs to do.
        showRefreshButton: false,
        showSignOutButton: true,
        heading: 'You do not have access.',
        message: `Your organization's identity provider signed you in, but this account has not
                  been granted access to the Evident application. Please contact your
                  administrator.`,
    },
    'unactivated': {
        // Same dead end as access-denied, and reached from the same adapter redirect: the person
        // holds a live Auth0 session for an address with no account here. Refresh would repeat the
        // refusal; sign-out lets them try a different address instead of editing the URL.
        showRefreshButton: false,
        showSignOutButton: true,
        heading: 'Uh oh, something went wrong!',
        message: `There is no account associated with the email address provided. Please contact your administrator to request access to the Evident application.`,
    },
};
